import React from 'react'
import { useTranslation } from 'react-i18next'
import { Language, LANGUAGE_LABELS } from '../lib/i18n'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  HStack,
  Text,
  useMediaQuery,
} from '@chakra-ui/react'
import { MdLanguage } from 'react-icons/md'
import Cookies from 'js-cookie'

/*********************
 * 🌐 언어 전환 컴포넌트
 *
 * - 한글/영어 전환 드롭다운 메뉴
 * - 현재 선택된 언어 표시
 * - 쿠키에 자동 저장 (EXGO_LANG)
 *********************/

interface LanguageSwitcherProps {
  variant?: 'text' | 'icon' | 'both'
  iconColor?: string
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  variant = 'both',
  iconColor,
}) => {
  const { i18n } = useTranslation()
  const [isMobile] = useMediaQuery('(max-width: 768px)')
  const currentLanguage = i18n.language as Language

  /*********************
   * 🔄 언어 변경 핸들러
   * - i18n.changeLanguage()로 언어 전환
   * - 쿠키에 자동 저장 (EXGO_LANG, 365일 유효)
   *********************/
  const handleLanguageChange = (lang: Language) => {
    i18n.changeLanguage(lang)
    Cookies.set('EXGO_LANG', lang, { expires: 365 })
  }

  /*********************
   * 🎨 버튼 내용 렌더링
   *********************/
  const renderButtonContent = () => {
    if (variant === 'icon') {
      return (
        <Icon as={MdLanguage} color={iconColor} width="22px" height="22px" />
      )
    }

    if (variant === 'text') {
      return <Text color={iconColor}>{LANGUAGE_LABELS[currentLanguage]}</Text>
    }

    return (
      <HStack spacing={1}>
        <Icon as={MdLanguage} color={iconColor} />
        <Text color={iconColor}>{LANGUAGE_LABELS[currentLanguage]}</Text>
      </HStack>
    )
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        aria-label="언어 선택"
        paddingX={0}
        width="40px"
        height="40px"
        // chakra ui 반응형 작업
        {...(isMobile && { width: 'auto', height: 'auto' })}
      >
        {renderButtonContent()}
      </MenuButton>
      <MenuList minW="120px">
        <MenuItem
          onClick={() => handleLanguageChange('ko')}
          bg={currentLanguage === 'ko' ? 'gray.100' : 'transparent'}
          _hover={{ bg: 'gray.50' }}
        >
          한국어
        </MenuItem>
        <MenuItem
          onClick={() => handleLanguageChange('en')}
          bg={currentLanguage === 'en' ? 'gray.100' : 'transparent'}
          _hover={{ bg: 'gray.50' }}
        >
          English
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default LanguageSwitcher
